module.exports = __webpack_public_path__ + "media/images/img_star_02-7eb81d2c217bbacc51e89d61cf65b1a7.png";